import React from 'react';
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

import ReactPaginate from 'react-paginate';

export default function Pagination({total, limit, paginationChange}) {
    return (
        <>
            <div className="rn-pagination text-center">
                {
                    (total > limit) && (
                        <ReactPaginate
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={Math.ceil(total / limit)}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={5}
                        onPageChange={(data) => paginationChange({data})}
                        containerClassName={'page-list'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        activeClassName={'active'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                        previousLabel={<FaAngleLeft />}
                        nextLabel={<FaAngleRight />}
                        />
                    )
                }
            </div>
        </>
    )
}